import React from 'react'
import UserHeader from '../../components/user/UserHeader.tsx'
import AppWrapper from '../../components/ui/AppWrapper/AppWrapper.tsx'
import DebtPanel from '../../components/ui/DebtPanel/DebtPanel.tsx'
import NoDebtPanel from '../../components/ui/NoDebtPanel/NoDebtPanel.tsx'
import HistoryBtnPanel from '../../components/ui/HistoryBtnPanel.tsx'
import PayFeeBtn from '../../components/ui/PayFeeBtn/PayFeeBtn.tsx'
import HomeLink from '../../components/ui/HomeLink/HomeLink.tsx'
import AppSecondaryBtn from '../../components/ui/AppSecondaryBtn/AppSecondaryBtn.tsx'
import PaymentsLogoWrapper from '../../components/ui/PaymentsLogoWrapper/PaymentsLogoWrapper.tsx'

interface HomeViewState {
  isDebt: boolean
}

class HomeView extends React.Component<unknown, HomeViewState> {
  constructor(props: unknown) {
    super(props)
    this.state = {
      isDebt: true
    }
  }
  render() {
    const { isDebt } = this.state

    return (
      <>
        <UserHeader />
        <AppWrapper className="bg-white h-[80%]">
          {false && isDebt && <DebtPanel />}
          {false && !isDebt && <NoDebtPanel />}
          <HistoryBtnPanel />
          <PayFeeBtn />
          <HomeLink />
          <AppSecondaryBtn
            onClick={() => {
              localStorage.removeItem('token')
              document.location.reload()
            }}
            className="w-full mt-auto"
          >
            Выйти
          </AppSecondaryBtn>
          <PaymentsLogoWrapper />
        </AppWrapper>
      </>
    )
  }
}

export default HomeView
